import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://captains-cut.com";
export const SITE_NAME = "Captain's Cut";
const OG_IMAGE = `${SITE_URL}/og-image.png`;

/** Per-route document head. `path` must start with "/" ("/" for the homepage). */
export const Seo = ({ title, description, path = "/", noindex = false }) => {
  const url = `${SITE_URL}${path === "/" ? "/" : path}`;

  // The static <head> in public/index.html carries the same tags as a no-JS fallback for crawlers.
  // Once React renders the route-specific tags, drop the static copies so each tag exists exactly once.
  useEffect(() => {
    document.querySelectorAll("head [data-static-seo]").forEach((el) => el.remove());
  }, []);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Captain's Cut crest on black" />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
};
